import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import {
  Alert,
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  DatePicker,
  TimePicker,
  InputNumber,
  Tooltip,
  message,
} from "antd";
import moment from "moment-timezone";

import classes from "./RandomizeAdmin.css";
import {
  getDrugManagementStatus,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import { connect } from "react-redux";

import { getRandomizationSitesRequest } from "../../api/requests";

import { range } from "../../utils/range";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class Randomize extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,

      dispensingSites: [],
      siteListLoading: false,
      selectedToSite: null,
    };
  }

  async componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );

    const from_site_id = get(this.props, "site.code", null);
    if (from_site_id !== null) {
      await this.getRandomizationSitesList(from_site_id);
    }
  }

  componentWillUnmount() {
    moment.tz.setDefault();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const randomize = { ...values };

        if (values.stroke_onsent_date && values.stroke_onsent_time) {
          randomize.stroke_onsent = moment(
            `${values.stroke_onsent_date.format(
              "YYYY-MM-DD"
            )}T${values.stroke_onsent_time.format("HH:mm")}`
          )
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss");
        }
        if (values.baseline_ct_mri_date && values.baseline_ct_mri_time) {
          randomize.baseline_ct_mri = moment(
            `${values.baseline_ct_mri_date.format(
              "YYYY-MM-DD"
            )}T${values.baseline_ct_mri_time.format("HH:mm")}`
          )
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss");
        }
        delete randomize.stroke_onsent_date;
        delete randomize.stroke_onsent_time;
        delete randomize.baseline_ct_mri_time;
        delete randomize.baseline_ct_mri_date;

        if (values.birthdate) {
          randomize.birthdate = `${values.birthdate}-01-01`;
        }
        this.props.handleSubmit(randomize);
      }
    });
  };

  getRandomizationSitesList = async (from_site_id) => {
    this.setState({
      errorMessage: null,
      siteListLoading: true,
      responseMessage: null,
      dispensingSites: [],
    });

    try {
      const { data } = await getRandomizationSitesRequest(from_site_id);
      this.setState({
        dispensingSites: data.map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
        })),
        siteListLoading: false,
        selectedToSite: null,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", this.props.i18n.t("Error")),
      });
    }
    this.setState({ siteListLoading: false });
  };

  onFromChange = async (value) => {
    this.props.form.setFieldsValue({ storage_id: null });
    try {
      await this.getRandomizationSitesList(value);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", this.props.i18n.t("Error")));
      console.log(e);
    }
  };

  getNow = () => {
    return moment
      .utc(get(this.props, "subject.randomization_date"))
      .tz(
        this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
      );
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      loading,
      sites,
      randomizationConducted,
      isEditableRandomize,
      isDrugManagementActive
    } = this.props;
    const { dispensingSites } = this.state;

    const isEditable = isEditableRandomize && !randomizationConducted;

    return (
      <Row className={classes.wrapper}>
        <Col md={24} lg={18}>
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={12}>
              <Col md={24}>
                <label>
                  <b>{this.props.i18n.t("Site*")}</b>
                  <Form.Item>
                    {getFieldDecorator("site", {
                      rules: [
                        {
                          required: true,
                          message: this.props.i18n.t("Please input site id"),
                        },
                      ],
                      initialValue: get(this.props.site, "code"),
                    })(
                      <Select
                        placeholder={this.props.i18n.t("Select site")}
                        disabled={!isEditable}
                        onChange={this.onFromChange}
                      >
                        {sites.map(({ code, name }) => (
                          <Option value={code} key={code}>
                            {name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              {isDrugManagementActive && (
                <Col span={24}>
                  <label>
                    <b>{this.props.i18n.t("Active Fridge*")}</b>
                    <Form.Item>
                      {getFieldDecorator("storage_id", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                        initialValue: get(this.props, "drug_location.id", null),
                      })(
                        <Select
                          disabled={!isEditable || this.props.siteListLoading}
                          placeholder={this.props.i18n.t("Select")}
                        >
                          {map(dispensingSites, ({ value, label }) => (
                            <Option key={value} value={value}>
                              {label}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>
              )}

              <Col md={24}>
                <label>
                  <b>
                    {this.props.i18n.t("NamespaceRandomizeAdmin:Profile code*")}
                  </b>
                  <Form.Item>
                    {getFieldDecorator("profileCode", {
                      rules: [
                        {
                          required: true,
                        },
                      ],
                      initialValue: this.props.profileCode,
                    })(
                      <Input
                        disabled={true}
                        placeholder={this.props.i18n.t(
                          "NamespaceRandomizeAdmin:profile code"
                        )}
                        allowClear
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  isDrugManagementActive: getDrugManagementStatus(state),
});

const RandomizeForm = Form.create()(
  connect(mapStateToProps)(withNamespaces()(Randomize))
);

export default RandomizeForm;



// WEBPACK FOOTER //
// ./src/components/Randomize/RandomizeAdmin.js